<template>
  <div>
    <div class="content">

      <div class="relative-top-fourthly">

        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <img class="img-circle profile-img" v-if="isLogin" v-bind:src="user.profileURL">
              <img class="img-circle profile-img" v-if="!isLogin" src="../assets/default_user_icon.png">
            </div>
            <div class="weui-cell__bd">
              <div v-show="isLogin">
                <p>{{user.chineseLastname}}{{user.chinesename}} </p>
              </div>
            </div>
            <div class="weui-cell__ft" v-show="isLogin">
              <p>{{user.firstname}} {{user.lastname}}</p>
            </div>
            <div class="weui-cell__ft" v-show="!isLogin">
              <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_primary" @click="login">登录</a>
              <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_default" @click="signup">注册</a>
            </div>
          </div>
        </div>

        <div class="weui-cells">
          <div class="weui-cell">
            <div class="row">
              <div class="column center left-column">
                <p v-if="isLogin">{{user.money.balance}}</p>
                <p v-if="!isLogin">--</p>
                <p>余额</p>
              </div>
              <div class="column center right-column">
                <p v-if="isLogin">{{user.money.blockedBalance}}</p>
                <p v-if="!isLogin">--</p>
                <p>冻结金额</p>
              </div>
            </div>
          </div>
        </div>

        <div class="weui-cells">
          <a class="weui-cell weui-cell_access" href="javascript:;" @click="profile">
            <div class="weui-cell__hd"><img src="../assets/personal_info.png" alt="" class="cell-icon"></div>
            <div class="weui-cell__bd">
              <p>个人信息</p>
            </div>
          </a>
          <a class="weui-cell weui-cell_access" href="javascript:;" @click="card">
            <div class="weui-cell__hd"><img src="../assets/my_qr.png" alt="" class="cell-icon"></div>
            <div class="weui-cell__bd">
              <p>我的二维码</p>
            </div>
          </a>
          <a class="weui-cell weui-cell_access" href="javascript:;" @click="hotline">
            <div class="weui-cell__hd"><img src="../assets/help_icon.png" alt="" class="cell-icon"></div>
            <div class="weui-cell__bd">
              <p>实时客服帮助</p>
            </div>
          </a>
        </div>

        <div class="weui-cells logout" v-if="isLogin">
          <div class="weui-cell weui-cell_access" @click="logout">
            <div class="weui-cell__bd center">
              <p>退出登录</p>
            </div>
          </div>
        </div>

        <div class="weui-footer footer">
          <p class="weui-footer__links">
            <a href="javascript:void(0);" @click="terms" class="weui-footer__link">用户协议</a>
            <a href="javascript:void(0);" @click="terms" class="weui-footer__link">隐私政策</a>
          </p>
          <p class="weui-footer__text">Copyright &copy; 2016-2017 小幕（北京）科技有限公司</p>
        </div>

      </div>
    </div>

    <tab-bar></tab-bar>
    <download-app></download-app>
    <we-reactive-dialog
      v-bind:is-show-dialog="isShowDownloadDialog"
      v-on:secondOnClick="cancelDownload"
      v-on:mainOnClick="doDownload">
      <div slot="title">下载APP</div>
      <div slot="content">目前仅支持APP内注册</div>
      <div slot="main-operation">去下载</div>
      <div slot="secondly-operation">取消</div>
    </we-reactive-dialog>
  </div>
</template>

<script>
  import router from '../conf/router'
  import TabBar from '../components/TabBar'
  import DownloadApp from '../components/DownloadApp'
  import WeReactiveDialog from '../components/WeReactiveDialog'

  export default{
    data () {
      return {
        isShowDownloadDialog: false
      }
    },

    methods: {
      login () {
        this.$store.commit('setShowLogin', true)
      },

      logout () {
        this.$store.dispatch('setUserInfo', {})
        window.window.sessionStorage.user = JSON.stringify({})
      },

      card () {
        router.push('/Card')
      },

      profile () {
        router.push('/Profile')
      },

      hotline () {
        window.location = 'https://static.meiqia.com/dist/standalone.html?eid=36824'
      },

      terms () {
        window.location = 'https://www.yituishui.com/application/terms'
      },

      signup () {
        this.isShowDownloadDialog = true
      },

      cancelDownload () {
        this.isShowDownloadDialog = false
      },

      doDownload () {
        window.location = 'https://www.yituishui.com/application/download'
      }
    },

    computed: {
      isLogin () {
        return this.$store.getters.getIsLogin
      },
      user () {
        return this.$store.getters.getUserInfo
      }
    },

    components: {
      TabBar,
      DownloadApp,
      WeReactiveDialog
    }
  }
</script>

<style lang="stylus">
  @import '../style/base.css'
  .profile-img
    width 70px
    height 70px
    display block
    margin-right 16px
  .logged-in
    position relative
  .footer
    margin-top 120px
    margin-bottom 51px
  .cell-icon
    width 20px
    margin-right 5px
    display:block
  .column
    float left
    width 50%
  .row
    width 100%
  .left-column
    color #2dc770
  .right-column
    color #428CBC
  .logout
    margin-top 100px
</style>



// WEBPACK FOOTER //
// Me.vue?7f40989e